import React, { forwardRef } from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { className = "", variant = "primary", size = "md", children, ...props },
    ref
  ) => {
    const baseStyles =
      "font-normal inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none cursor-pointer";

    const variants = {
      // Primary: Golden/amber background matching Figma #e07828
      primary: "bg-[#e07828] hover:bg-[#c99800] text-white rounded",
      secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200 rounded-lg",
      // Outline: White background with #706f6f border and text to match Figma
      outline:
        "border border-[#706f6f] bg-white hover:bg-gray-50 text-[#706f6f] rounded-md",
      ghost: "hover:bg-gray-100 text-gray-700 rounded-lg",
    };

    const sizes = {
      sm: "h-9 px-3 text-xs gap-2",
      // Medium size matching Figma's filter buttons (~39px height)
      md: "h-10 px-4 py-1.5 text-sm gap-2",
      // Large size matching Figma's primary "Add new Enroll" button
      lg: "h-10 px-6 py-2.5 text-base gap-2",
    };

    return (
      <button
        ref={ref}
        className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";
